import securityManager from "../../../services/managers/security";
import { WHITEBOARD_INITIAL_STATE, WHITEBOARDS_MAX_LIMIT } from "../../../services/managers/constants";

export const onAddNewWhiteboardClick = (state, action) => {
  let chartWhiteboards = state.chartWhiteboards.slice();

  if (chartWhiteboards.length < WHITEBOARDS_MAX_LIMIT) {
    // Create a new instance of the Whiteboard
    let newWhiteboard = { ...WHITEBOARD_INITIAL_STATE, __id: securityManager.generateKey(), __change_detection_key: securityManager.generateKey() };

    // Set default selected Lot Size
    if (state.costToTradeLotSizes && state.costToTradeLotSizes.length) {
      newWhiteboard.selectedCostToTradeLotSizes[0] = state.costToTradeLotSizes[0].Key;
    }

    // Add newly created Whiteboard to the list
    chartWhiteboards.push(newWhiteboard);
    return { ...state, chartWhiteboards };
  }

  return { ...state };
};

export const onRemoveWhiteboardClick = (state, action) => {
  let chartWhiteboards = state.chartWhiteboards.slice();
  // Remove Whiteboard from the list
  chartWhiteboards.splice(action.payload.whiteboardIndex, 1);
  return { ...state, chartWhiteboards };
};



// WEBPACK FOOTER //
// ./src/store/analytics/chart-footer/action-handlers.js